export default {
  work_experience_organization: 'work_experience',
  work_experience_organization_details: 'work_experience',
  work_experience_organization_name: 'work_experience',
  work_experience_organization_address: 'work_experience',
  work_experience_role_details: 'work_experience',

  skill_organization: 'skill',
  skill_organization_details: 'skill',
  skill_organization_name: 'skill',
  skill_title: 'skill',

  education_organization: 'education',
  education_organization_details: 'education',
  education_organization_name: 'education',
  education_organization_address: 'education',
  education_role_details: 'education',

  awards_and_honors_organization: 'awards_and_honors',
  awards_and_honors_organization_details: 'awards_and_honors',
  awards_and_honors_organization_name: 'awards_and_honors',
  awards_and_honors_organization_address: 'awards_and_honors',
  awards_and_honors_role_details: 'awards_and_honors',

  volunteer_work_organization: 'volunteer_work',
  volunteer_work_organization_details: 'volunteer_work',
  volunteer_work_organization_name: 'volunteer_work',
  volunteer_work_organization_address: 'volunteer_work',
  volunteer_work_role_details: 'volunteer_work',

  certifications_organization: 'certifications',
  certifications_organization_details: 'certifications',
  certifications_organization_name: 'certifications',
  certifications_organization_address: 'certifications',
  certifications_role_details: 'certifications',

  projects_organization: 'projects',
  projects_organization_details: 'projects',
  projects_organization_name: 'projects',
  projects_organization_address: 'projects',
  projects_role_details: 'projects',

  research_experience_organization: 'research_experience',
  research_experience_organization_details: 'research_experience',
  research_experience_organization_name: 'research_experience',
  research_experience_organization_address: 'research_experience',
  research_experience_role_details: 'research_experience',

  leadership_organization: 'leadership',
  leadership_organization_details: 'leadership',
  leadership_organization_name: 'leadership',
  leadership_organization_address: 'leadership',
  leadership_role_details: 'leadership',

  associations_organization: 'associations',
  associations_organization_details: 'associations',
  associations_organization_name: 'associations',
  associations_organization_address: 'associations',
  associations_role_details: 'associations',

  extra_curricular_organization: 'extra_curricular',
  extra_curricular_organization_details: 'extra_curricular',
  extra_curricular_organization_name: 'extra_curricular',
  extra_curricular_organization_address: 'extra_curricular',
  extra_curricular_role_details: 'extra_curricular',

  courses_organization: 'courses',
  courses_organization_details: 'courses',
  courses_organization_name: 'courses',
  courses_organization_address: 'courses',
  courses_role_details: 'courses',

  conferences_organization: 'conferences',
  conferences_organization_details: 'conferences',
  conferences_organization_name: 'conferences',
  conferences_organization_address: 'conferences',
  conferences_role_details: 'conferences',

  references_organization: 'references',
  references_organization_details: 'references',
  references_organization_name: 'references',
  references_organization_address: 'references',
  references_role_details: 'references',

  patents_organization: 'patents',
  patents_organization_details: 'patents',
  patents_organization_name: 'patents',
  patents_organization_address: 'patents',
  patents_role_details: 'patents',

  test_scores_organization: 'test_scores',
  test_scores_organization_details: 'test_scores',
  test_scores_organization_name: 'test_scores',
  test_scores_organization_address: 'test_scores',
  test_scores_role_details: 'test_scores',
};
